module.exports = __webpack_public_path__ + "roc360.017d777.png";